/**
 * Multi-tenant client contracts aligned with shared/tenant and tenant routers.
 */

export type {
  TenantFeature as TenantFeatureKey,
  TenantFeatureFlags as TenantFeatures,
  TenantRole,
  TenantStatus,
} from "../../shared/tenant";

export {
  DEFAULT_TENANT_FEATURES,
  TENANT_FEATURES as TENANT_FEATURE_KEYS,
} from "../../shared/tenant";

export const TENANT_FEATURE_LABELS = {
  dispatch_monitor: "发单监控",
  script_monitor: "剧本监测",
  atmosphere_assistant: "气氛员助手",
  speech_points: "发言积分",
  ai_management: "AI 管理",
} as const;

export interface TenantSummary {
  id: string;
  name: string;
  code?: string | null;
  status: string;
}

export interface TenantContextValue {
  homeTenant: TenantSummary;
  activeTenant: TenantSummary;
  role: import("../../shared/tenant").TenantRole;
  isPlatformSuperAdmin: boolean;
  features: import("../../shared/tenant").TenantFeatureFlags;
  status: string;
}

export interface TenantRecord {
  id: string;
  name: string;
  code?: string | null;
  status: string;
  features: import("../../shared/tenant").TenantFeatureFlags;
  createdAt?: string | Date | null;
  updatedAt?: string | Date | null;
  remark?: string | null;
}

export interface TenantUserRecord {
  id: string;
  username?: string | null;
  name: string;
  email?: string | null;
  role: "tenant_admin" | "member" | string;
  banned?: boolean | null;
  banReason?: string | null;
  createdAt?: string | Date | null;
  updatedAt?: string | Date | null;
}

export interface TenantUserListResult {
  users: TenantUserRecord[];
  total: number;
}
